import { HTMLAttributes, ReactNode } from 'react';

import * as S from './styles';

export interface CheckboxProps extends HTMLAttributes<HTMLInputElement> {
  required?: boolean;
  name?: string;
  isValid?: boolean;
  feedbackMessage?: ReactNode;
  children?: JSX.Element | string;
  disabled?: boolean;
}

const Checkbox = ({
  required = false,
  isValid = true,
  feedbackMessage,
  name,
  children,
  className,
  disabled = false,
  ...props
}: CheckboxProps) => {
  return (
    <S.Label htmlFor={name}>
      <S.Container className={className}>
        <S.Field
          name={name}
          type="checkbox"
          id={name}
          {...props}
          disabled={disabled}
        />
        <S.Checkmark error={!isValid} />
        <div>
          <S.Content required={required}>{children}</S.Content>
          {!isValid && feedbackMessage && (
            <S.FeedbackMessage>{feedbackMessage}</S.FeedbackMessage>
          )}
        </div>
      </S.Container>
    </S.Label>
  );
};

export default Checkbox;
